export const getClientStatus = (client: any) => {
  // Check if client has any documents
  const hasDocuments = client.documents && client.documents.length > 0;
  
  // Check if client has any notes
  const hasNotes = client.notes && client.notes.trim() !== '';
  
  // Check if client has a payment plan
  const hasPaymentPlan = client.paymentPlan;

  if (client.status === 'Active') {
    if (!hasDocuments || !hasNotes || !hasPaymentPlan) {
      return 'Pending Remarks';
    }
    return 'Active';
  }
  
  return client.status;
};

export const getStatusStyles = (status: string) => {
  switch (status) {
    case 'Active':
      return 'bg-green-500/20 text-green-400 border-green-500/30';
    case 'Pending':
      return 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30';
    case 'Pending Remarks':
      return 'bg-orange-500/20 text-orange-400 border-orange-500/30';
    default:
      return 'bg-gray-500/20 text-gray-400 border-gray-500/30';
  }
};